import React from 'react'

import { cva, type VariantProps } from 'class-variance-authority'

import { cn } from '@/lib/utils.ts'

import { Icons } from '../Icons/Icons.tsx'

const televisionButtonVariants = cva('group flex size-10 items-center justify-center', {
  variants: {
    state: {
      default: 'bg-gray-800',
      active: 'bg-orange-500',
    },
  },
  defaultVariants: {
    state: 'default',
  },
})

const iconVariants = cva('size-5 stroke-white', {
  variants: {
    state: {
      default: 'group-hover:stroke-orange-500',
      active: '',
    },
  },
  defaultVariants: {
    state: 'default',
  },
})

export interface TelevisionButtonProps
  extends React.ButtonHTMLAttributes<HTMLButtonElement>, VariantProps<typeof televisionButtonVariants> {}

export const TelevisionButton = React.forwardRef<HTMLButtonElement, TelevisionButtonProps>(
  ({ className, state, ...props }, ref) => (
    <button type="button" className={cn(televisionButtonVariants({ state, className }))} ref={ref} {...props}>
      <Icons.television className={cn(iconVariants({ state }))} />
    </button>
  )
)
